import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar, Mail, Phone } from "lucide-react";
import { clientAPI } from "@/lib/client-api";

const BookSection = () => {
  const [section, setSection] = useState({ title: "", description: "", email: "", phone: "" });

  useEffect(() => {
    const loadData = () => {
      const data = clientAPI.getBookSection();
      if (data) {
        setSection(data);
      }
    };

    loadData();

    // Listen for updates from admin panel
    window.addEventListener('contentUpdated', loadData);
    return () => window.removeEventListener('contentUpdated', loadData);
  }, []);

  return (
    <section id="book" className="py-20 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-4xl text-center">
        <div className="animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {section.title}
          </h2>
          <div className="w-20 h-1 bg-white mx-auto mb-8"></div>
          <p className="text-lg md:text-xl mb-10 opacity-90">
            {section.description}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button
              size="lg"
              variant="secondary"
              className="bg-white text-primary hover:bg-white/90 text-lg px-8 py-6"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Check Availability
            </Button>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg">
              <Mail className="h-5 w-5" />
              <span>{section.email}</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg">
              <Phone className="h-5 w-5" />
              <span>{section.phone}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
